/** 퇴임 이사 재선임 — retiringDirectors 동기화 (Create / Edit 공통). */

export interface RetiringDirectorRow {
  name: string;
}

function trimName(raw: unknown): string {
  return raw === null || raw === undefined ? '' : String(raw).trim();
}

function collectDirectorNames(
  entityDirectors: Array<{ name?: string }>,
  directorsFromEntity: Array<{ name?: string }>,
): string[] {
  const seen = new Set<string>();
  const names: string[] = [];
  const pushName = (raw: unknown) => {
    const name = trimName(raw);
    if (!name) return;
    const key = name.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    names.push(name);
  };
  for (const d of entityDirectors || []) pushName(d.name);
  if (names.length === 0) {
    for (const d of directorsFromEntity || []) pushName(d.name);
  }
  return names;
}

/**
 * Edit: 저장된 director 행(이름 있음)이 있으면 유지.
 * Edit + 목록 비어 있음 / Create: entity director 로 채움.
 */
export function syncRetiringDirectorsRows(input: {
  editMode: boolean;
  retiringDirectors: RetiringDirectorRow[];
  entityDirectors: Array<{ name?: string }>;
  directorsFromEntity: Array<{ name?: string }>;
}): RetiringDirectorRow[] {
  const savedRows = (input.retiringDirectors || []).filter((r) => trimName(r?.name));
  if (input.editMode && savedRows.length > 0) {
    return input.retiringDirectors;
  }

  const names = collectDirectorNames(input.entityDirectors, input.directorsFromEntity);
  if (names.length > 0) {
    return names.map((name) => ({ name }));
  }
  if ((input.retiringDirectors || []).length === 0) {
    return [{ name: '' }];
  }
  return input.retiringDirectors;
}
